// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  ruleset: __t.string(),
  territoryId: __t.string().name("territory_id"),
  challengerPlayerId: __t.string().name("challenger_player_id"),
  defenderPlayerId: __t.string().name("defender_player_id"),
  status: __t.string(),
  sourceMatchId: __t.option(__t.string()).name("source_match_id"),
  challengeMatchId: __t.option(__t.string()).name("challenge_match_id"),
  createdAt: __t.timestamp().name("created_at"),
  resolvedAt: __t.option(__t.timestamp()).name("resolved_at"),
});
